import {FileFieldConfig, FileFieldValue} from '@dms/api/vehicle';
import i18n from '@dms/i18n';

import {Nullish} from 'shared/web';

export const buildBatteryCertificateFileFields = (
  batteryCertificateDocument: FileFieldValue | Nullish
): FileFieldConfig[] => [
  {
    fieldValue: batteryCertificateDocument,
    documentNote: i18n.t('entity.vehicle.labels.batteryCertificate'),
  },
];
